<template>
  <div>
    <catalog-select
      ref="catalog_select"
      catalog-name="вид работ"
      :is-disabled="isDisabled"
      :initial-value="value"
      :get-item-by-id="getWorkType"
      :get-list="getItems"
      :can-create-catalog="canEditWorkType()"
      @onSelect="$emit('onSelect', $event)"
      @open-modal="isModalVisible = true"
    />

    <work-type-catalog
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import CatalogSelect from "../CatalogSelect.vue";
    import WorkTypeCatalog from "./WorkTypeCatalog.vue";

export default {
  name: "WorkTypeSelect",
  components: { WorkTypeCatalog, CatalogSelect},
  mixins: [
    catalogs,
    permissions
  ],
  props: {
    isDisabled: { type: Boolean, default: null },
    value: { type: Number, default: null },
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    async getItems() {
      const result = await this.getWorkTypeCatalogs({});
      return (result && result.data && result.data.items) ? result.data.items : [];
    },
    async getWorkType(id) {
      const result = await this.getWorkTypeById(id);
      return (result && result.data) ? result.data : null;
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.isModalVisible = false;
    },
    canEditWorkType() {
      return this.hasPermission([PERM.CATALOG_WORK_TYPE_EDIT]);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkType/WorkTypeSelect.vue